module.exports = __webpack_public_path__ + "static/media/2.e3c0ac04.png";